import React from "react";
import {
  Card,
  CardContent,
  Chip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import {
  Android as AiIcon,
  AttachMoney as MoneyIcon,
  Business as BusinessIcon,
  Chat as ChatIcon,
  Edit as EditIcon,
  Extension as IntegrationIcon,
  Group as GroupIcon,
  Http as ApiIcon,
  Notifications as CampaignIcon,
  Phone as PhoneIcon,
  Queue as QueueIcon,
  Schedule as ScheduleIcon,
  Star as StarIcon,
  ViewList as KanbanIcon,
} from "@material-ui/icons";
import { i18n } from "../../translate/i18n";
import { useStyles } from "./planManagerStyles";

export function PlansManagerGridImproved(props) {
  const { records, onSelect } = props;
  const classes = useStyles();

  const renderStatus = (value) => {
    return value ? (
      <Chip label="Sí" size="small" className={classes.enabledChip} />
    ) : (
      <Chip label="No" size="small" className={classes.disabledChip} />
    );
  };

  // I-3: useInternal tiene lógica invertida — false = plan de uso interno ("Sí"), true = no es interno ("No")
  const renderInternal = (value) => {
    return !value ? (
      <Chip label="Sí" size="small" className={classes.enabledChip} />
    ) : (
      <Chip label="No" size="small" className={classes.disabledChip} />
    );
  };

  if (records.length === 0) {
    return (
      <Card className={classes.tableCard}>
        <CardContent className={classes.emptyState}>
          <Typography variant="h6" color="textSecondary">
            No hay planes registrados
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Crea tu primer plan para comenzar
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={classes.tableCard}>
      <Table>
        <TableHead className={classes.tableHeader}>
          <TableRow>
            <TableCell align="center" style={{ width: "60px" }}>#</TableCell>
            <TableCell align="left">
              <StarIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.name")}
            </TableCell>
            <TableCell align="center">
              <GroupIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.users")}
            </TableCell>
            <TableCell align="center">
              <PhoneIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.connections")}
            </TableCell>
            <TableCell align="center">
              <QueueIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.queues")}
            </TableCell>
            <TableCell align="center">
              <MoneyIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.value")}
            </TableCell>
            <TableCell align="center">
              <CampaignIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.campaigns")}
            </TableCell>
            <TableCell align="center">
              <ScheduleIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.schedules")}
            </TableCell>
            <TableCell align="center">
              <ChatIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.internalChat")}
            </TableCell>
            <TableCell align="center">
              <ApiIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.externalApi")}
            </TableCell>
            <TableCell align="center">
              <KanbanIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.kanban")}
            </TableCell>
            <TableCell align="center">
              <AiIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.openAi")}
            </TableCell>
            <TableCell align="center">
              <IntegrationIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.integrations")}
            </TableCell>
            <TableCell align="center">
              <BusinessIcon style={{ marginRight: 8 }} />
              {i18n.t("plans.form.internalPlan")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((row, key) => (
            <TableRow
              className={classes.tableRow}
              key={key}
              onClick={() => onSelect(row)}
            >
              <TableCell align="center" className={classes.tableCell}>
                <Tooltip title="Editar plan">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelect(row);
                    }}
                    className={classes.editButton}
                    size="small"
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
              <TableCell align="left" className={classes.tableCell}>
                <Typography variant="body2" style={{ fontWeight: "bold" }}>
                  {row.name || '-'}
                </Typography>
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {row.users || '-'}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {row.connections || '-'}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {row.queues || '-'}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                <Typography variant="body2" style={{ fontWeight: "bold", color: "#2e7d32" }}>
                  ${row.value ? row.value.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : '00.00'}
                </Typography>
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {renderStatus(row.useCampaigns)}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {renderStatus(row.useSchedules)}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {renderStatus(row.useInternalChat)}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {renderStatus(row.useExternalApi)}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {renderStatus(row.useKanban)}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {renderStatus(row.useOpenAi)}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {renderStatus(row.useIntegrations)}
              </TableCell>
              <TableCell align="center" className={classes.tableCell}>
                {renderInternal(row.useInternal)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}

export default PlansManagerGridImproved;
